/**
 * 가로 메뉴·프로필 드롭다운에 view 권한 기반 필터를 적용할지 여부.
 * 전 관할 적용 (MY·비-MY 공통, `isMY || !isMY`와 동등).
 */
export function shouldApplyDeptMenuVisibilityForJurisdiction(jurisdictionRaw: string | null | undefined): boolean {
    const j = String(jurisdictionRaw || '').toUpperCase();
    const isMY = j === 'MY' || j === 'MALAYSIA';
    return isMY || !isMY;
}
